import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
var PostponeComponent = (function () {
    function PostponeComponent(_data, _blogic) {
        this._data = _data;
        this._blogic = _blogic;
        this.destroy$ = new Subject();
    }
    PostponeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._updateTurn(this._data.turn);
        this._data.turnUpdate
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._updateTurn(response);
        });
    };
    PostponeComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    PostponeComponent.prototype._updateTurn = function (turn) {
        if (!this._data.turnIsActive()) {
            this.turn = null;
        }
        else {
            this.turn = turn;
        }
    };
    /* Recover finished turn */
    PostponeComponent.prototype.postponeTurn = function () {
        var _this = this;
        var params = {
            turn_id: this._data.turn["id"],
        };
        this._blogic.setPostpone(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (response) {
            _this._data.closeTurn();
        });
    };
    return PostponeComponent;
}());
export { PostponeComponent };
